// extracted by mini-css-extract-plugin
module.exports = {"lineup_wrap":"EventLineup_lineup_wrap__6Pf4n","lineup":"EventLineup_lineup__lPPxY","people":"EventLineup_people__DFXZO","lineup_img":"EventLineup_lineup_img__ZBHlg"};